module.exports = __webpack_public_path__ + "static/media/CH1.1e34a36d.jpg";